module.exports = __webpack_public_path__ + "img/ducky_cn_tower.a31333c9.jpg";